import React, { useState } from 'react';
import { LibraryIcon } from 'lucide-react';
import Library from '../Processing/Library/components/Library';

interface URLInputWithLibraryProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    label: string;
    className?: string;
}

export default function URLInputWithLibrary({
    value,
    onChange,
    placeholder,
    label,
    className = '',
}: URLInputWithLibraryProps) {
    const [showLibrary, setShowLibrary] = useState(false);

    const handleImageSelected = (imageUrl: string) => {
        onChange(imageUrl);
        setShowLibrary(false);
    };

    return (
        <>
            <div className={`mb-3 ${className}`}>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                    {label}
                </label>
                <div className="flex gap-2">
                    <input
                        type="text"
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder={placeholder}
                        className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                        type="button"
                        onClick={() => setShowLibrary(true)}
                        className="px-3 py-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-md transition-colors flex items-center justify-center"
                        title="Select from Library"
                    >
                        <LibraryIcon className="w-4 h-4 text-gray-600" />
                    </button>
                </div>
            </div>

            {/* Library Modal */}
            {showLibrary && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
                    <div className="max-w-6xl max-h-[90vh] overflow-hidden">
                        <Library
                            onImageSelected={handleImageSelected}
                            onClose={() => setShowLibrary(false)}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
